import React, {useState} from "react";
import profile from "../assets/profile2.png";
import copy from "../assets/copy.png";
import "./Banner.css";
const Banner = ({ activeIndex, setActiveIndex }) => {
  const getActiveClass = (i) => {
    return i === activeIndex ? "active" : "";
  };
  return (
    <div className="relative">
      <div className="mt-[51px] flex flex-col md:flex-row items-center gap-[40px] p-[40px]  bg-custom-gradient rounded-[12px]">
        <div className="w-[274px]  relative z-[15]">
          <img className="rounded-[20px]" src={profile} alt="" />
        </div>
        <div className="grow">
          <h2 className="text-main-black text-res-ls leading-[28px]">
            My Profile
          </h2>
          <h2 className="text-normal font-bold text-main-black mb-[8px] md:text-[36px] md:leading-[44px]">
            DdzFFzCqrhshMSx....
          </h2>
          <p className="max-w-[466px] text-res-xxs text-main-black mb-[24px]">
            Lorem ipsum dolor sit amet, consectetur adipisicing elit. Laborum
            obcaecati dignissimos quae quo ad iste ipsum officiis deleniti
            asperiores sit.
          </p>
          <button className="w-[190px] text-[13px] gap-[15px] bg-main-black flex h-[36px] pl-[20px] pr-[21px] rounded-[50px] items-center">
            <span>DdzFFzCqrhshMSx....</span>
            <img src={copy} alt="" />
          </button>
        </div>
      </div>
      <div className="xl:absolute overflow-hidden rounded-b-[12px] z-10 bottom-0 bg-main-black h-[74px] w-full py-[24px] flex justify-center">
        <div className="profile-menu-wrap xl:ml-[-80px]">
          <ul className="flex gap-4 md:gap-0">
            <li>
              <button
                onClick={() => setActiveIndex(0)}
                className={`m-0 ml-0  md:mr-[135px] ${getActiveClass(0)}`}
              >
                ALL
              </button>
            </li>
            <li>
              <button
                onClick={() => setActiveIndex(1)}
                className={`mr-0 md:mr-[121px]  ${getActiveClass(1)}`}
              >
                TIER 1
              </button>
            </li>
            <li>
              <button
                onClick={() => setActiveIndex(2)}
                className={`mr-0 md:mr-[135px]  ${getActiveClass(2)}`}
              >
                TIER 2
              </button>
            </li>
          </ul>
        </div>
      </div>
    </div>
  );
};

export default Banner;
